import { UserRolesDto } from '@observatory/shared/gard/dtos';
import { useGetUserInfo } from './get-user-info.hook';

export function useIsAdmin() {
  const { data, isLoading } = useGetUserInfo();

  return isLoading ? true : data?.role === UserRolesDto.ADMIN;
}
